import React, { useEffect, useState } from 'react';
import { getLaunchAtLogin, setLaunchAtLogin } from '../../services/launchAtLogin';
import { Toggle } from '../settingsPrimitives';

/**
 * Settings › Notifications › Window: "Open Apiboo when you sign in to your
 * computer". Shows the REAL state of the system's startup entry (Windows
 * startup apps, macOS Login Items, Linux autostart) — the user may have
 * switched it off there — and writes it on change (services/launchAtLogin.js).
 */
export default function LaunchAtLoginToggle() {
  const [on, setOn] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    getLaunchAtLogin().then((v) => live && setOn(v));
    return () => {
      live = false;
    };
  }, []);

  const change = async (next) => {
    setBusy(true);
    setError('');
    try {
      setOn(await setLaunchAtLogin(next));
    } catch (e) {
      setError(typeof e === 'string' ? e : 'That did not work. Try again.');
      setOn(await getLaunchAtLogin());
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Toggle value={Boolean(on)} onChange={change} disabled={busy || on === null} />
      {error && <p className="text-xs text-red-500 mt-1" role="alert">{error}</p>}
    </>
  );
}
